import React from 'react';
import styled, { css } from 'styled-components';
import Icon from '~/components/atom/Icon';

type Props = {
  onClick: () => void;
};

const text = {
  ariaLabel: 'Open chat',
};

// Shows the Intercom button on dev environments where Intercom is not launched
const MockedIntercomButton: React.FC<Props> = ({ onClick }) => (
  <Button
    onClick={onClick}
    aria-label={text.ariaLabel}
    type="button"
    data-testid="mocked-intercom-button"
  >
    <Icon name="intercom" color={{ group: 'primary' }} />
  </Button>
);

const Button = styled.button<{}>(
  ({ theme }) => css`
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: white;
    border: 2px solid ${theme.color('white')};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow:
      0 1px 6px 0 rgba(0, 0, 0, 0.06),
      0 2px 32px 0 rgba(0, 0, 0, 0.16);
    z-index: 9999;
    transition: all 0.2s ease;

    &:hover {
      transition: transform 250ms cubic-bezier(0.33, 0, 0, 1);
      transform: scale(1.1);
    }

    &:active {
      transform: scale(0.95);
    }

    svg {
      width: 24px;
      height: 24px;
    }
  `,
);

export default MockedIntercomButton;
